/*
 * Generates a basic page to display that logging in is taking place
 */
import React from "react";
import Layout from "../components/Layout";
import { Paper, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3, 2)
  }
}));

const LoggingIn = () => {
  const classes = useStyles();

  return (
    <Layout>
      <Paper className={classes.root}>
        <Typography component="p">Logging in...</Typography>
      </Paper>
    </Layout>
  );
};

export default LoggingIn;
